<!--
 * @Descripttion: 地图指南针公共组件
 * @version: 
 * @Author: szj
 * @Date: 2025-03-25 13:51:41
 * @LastEditors: szj
 * @LastEditTime: 2025-03-25 15:56:57
-->
<template>
    <div class="heading-box" @click="resetHeading()">
        <div class="heading-img" :style="{transform: `rotateZ(${parseFloat(mapcompassInfo?.angle || 0)}deg)`}">
        </div>
        <div class="heading-compass">
          <div class="compass-orientation">{{ orientation }}</div>
          <div class="compass-angle">{{ mapcompassInfo?.angle || 0 }}°</div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, watch, computed } from "vue";
const props = defineProps({
  // 地图 heading角度
  mapcompassInfo: {
    type: Object,
    default: () => {
      return {
        angle: 0
      };
    },
  },
});
const emits = defineEmits(['resetHeading'])
const orientation = computed(()=>{
    let str = 'N'
    const angle = props.mapcompassInfo.angle
    if (angle) {
        if (angle > 20 && angle <= 70) {
            str = 'NE'
        }else if (angle > 70 && angle <= 110) {
            str = 'E'
        }else if (angle > 110 && angle <= 160) {
            str = 'SE'
        }else if (angle > 160 && angle <= 200) {
            str = 'S'
        }else if (angle > 200 && angle <= 250) {
            str = 'SW'
        }else if (angle > 250 && angle <= 290) {
            str = 'W'
        }else if (angle > 290 && angle <= 340) {
            str = 'NW'
        }else{
            str = 'N'
        }
    }
    return str
}) // 指南针指向
const angle = ref("000"); // 指南针度数
// 重置角度
const resetHeading = ()=>{
    emits('resetHeading')
}
</script>
<style lang="scss" scoped>
.heading-box {
  width: 56px;
  height: 56px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  position: relative;
  color: #595959;
  .heading-img{
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-origin: border-box;
    background-image: url("/@/assets/icons/photoimg1.svg");
  }
  .heading-compass {
    position: absolute;
    left: 7px;
    top: 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    font-weight: 700;
    display: flex;
    cursor: pointer;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-origin: border-box;
    background-image: url("/@/assets/icons/photocompass.svg");
    .compass-orientation {
      margin-top: 6px;
      font-size: 16px;
      line-height: 18px;
    }
    .compass-angle {
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>